import { authClient, LoginRequest, LoginResponse } from '@/core/sdk/modules/administracion/authClient';

/**
 * Servicio de autenticación que expone métodos para gestión de sesiones y recuperación de contraseña
 */
export const authService = {
  // Autenticación de sesiones
  login: async (credentials: LoginRequest): Promise<LoginResponse> => {
    return authClient.login(credentials);
  },

  logout: async (): Promise<void> => {
    await authClient.logout();
  },

  getProfile: async () => {
    return authClient.getProfile();
  },

  // Recuperación de contraseña
  solicitarRecuperacion: async (identificador: string) => {
    return authClient.solicitarRecuperacion(identificador);
  },

  restablecerContrasena: async (
    token: string,
    nuevaContrasena: string,
    confirmarContrasena: string
  ) => {
    return authClient.restablecerContrasena(token, nuevaContrasena, confirmarContrasena);
  },

  validarToken: async (token: string): Promise<boolean> => {
    return authClient.validarToken(token);
  },

  // Activación de cuenta
  activarCuenta: async (codigo: string) => {
    return authClient.activarCuenta(codigo);
  },

  // Refresh token
  refreshToken: async () => {
    return authClient.refreshToken();
  },

  // Validación de contraseña (para bloqueo de app)
  validatePassword: async (params: { usuarioId: string; contrasena: string }): Promise<boolean> => {
    return authClient.validatePassword(params);
  },
};

// Export por defecto y nombrado para máxima flexibilidad
export default authService;
